var Question, W, exportAssessmentSummary, exportConclusions, exportInterventions, exportIsof, exportJustification, exportPlr, exportPopulation, exportProgress, exportQuestionAndRecommendation, get, getCertaintyOfEvidenceAndLabel, getEtdPrintout, getRecommendationDirectionAndStrength, getRecommendationHeaderData, getRecommendationMetadata, getRecommendationMetadataOrUndefined, getRecommendationText, gradeProCodeToWHOCode, mediator, prepareCodes, rejectEmptyLinks, renderEditorValue, renderEditorValueFromRecommendationMetadata, _ref;

get = require('lodash').get;

_ref = require('lib/services/covid_exporter/utils'), exportConclusions = _ref.exportConclusions, exportIsof = _ref.exportIsof, exportJustification = _ref.exportJustification, exportPlr = _ref.exportPlr, getCertaintyOfEvidenceAndLabel = _ref.getCertaintyOfEvidenceAndLabel, getEtdPrintout = _ref.getEtdPrintout, getRecommendationDirectionAndStrength = _ref.getRecommendationDirectionAndStrength, getRecommendationMetadata = _ref.getRecommendationMetadata, getRecommendationHeaderData = _ref.getRecommendationHeaderData, getRecommendationMetadataOrUndefined = _ref.getRecommendationMetadataOrUndefined, getRecommendationText = _ref.getRecommendationText, gradeProCodeToWHOCode = _ref.gradeProCodeToWHOCode, prepareCodes = _ref.prepareCodes, renderEditorValue = _ref.renderEditorValue, renderEditorValueFromRecommendationMetadata = _ref.renderEditorValueFromRecommendationMetadata;

mediator = require('mediator');

Question = require('models/question');

W = require('when/when');

rejectEmptyLinks = function(value) {
  return _.isEmpty(value.link);
};

exportInterventions = function(question) {
  var interventions, _ref1, _ref2, _ref3, _ref4;
  switch (question.type) {
    case 'diagnostic':
      interventions = [
        {
          '@id': '_:int1',
          '@type': 'WHOIntervention',
          'name': question['indexTest'],
          'codes': prepareCodes((_ref1 = get(question, 'codes.indexTest')) != null ? _ref1 : {})
        }
      ];
      if (question['comparatorTestPresent']) {
        interventions.push({
          '@id': '_:int2',
          '@type': 'WHOIntervention',
          'name': question['comparatorTest'],
          'codes': prepareCodes((_ref2 = get(question, 'codes.comparatorTest')) != null ? _ref2 : {})
        });
      }
      return interventions;
    default:
      return [
        {
          '@id': '_:int1',
          '@type': 'WHOIntervention',
          'name': question['intervention'],
          'codes': prepareCodes((_ref3 = get(question, 'codes.intervention')) != null ? _ref3 : {}, {
            '@id': '_:int2',
            '@type': 'WHOIntervention',
            'name': question['comparison'],
            'codes': prepareCodes((_ref4 = get(question, 'codes.comparison')) != null ? _ref4 : {})
          })
        }
      ];
  }
};

exportPopulation = function(question, recommendation) {
  var attachments, setting, _ref1;
  attachments = get(recommendation, '_attachments', {});
  setting = renderEditorValue(get(recommendation, 'templateData.question.sections.setting.content'), attachments);
  if (!setting) {
    setting = question['settings'];
  }
  if (!setting) {
    setting = void 0;
  }
  return [
    {
      '@id': '_:pop1',
      '@type': 'WHOPopulation',
      'ages': _.reject(getRecommendationMetadata(recommendation, 'age'), function(v) {
        return v === 'any';
      }),
      'codes': prepareCodes((_ref1 = get(question, 'codes.population')) != null ? _ref1 : {}),
      'description': question['healthProblemOrPopulation'],
      'setting': setting
    }
  ];
};

exportAssessmentSummary = function(recommendation, exportAssessmentTextSections) {
  var attachments, sections, sectionsOrder, _ref1;
  attachments = get(recommendation, '_attachments', {});
  sectionsOrder = (_ref1 = get(recommendation, 'templateData.assessment.sectionsOrder')) != null ? _ref1 : [];
  sections = _.chain(sectionsOrder).map(function(key) {
    var additionalConsiderations, additionalOptions, criterionId, name, options, researchEvidences, selectedOption, value;
    criterionId = get(recommendation, "templateData.assessment.sections." + key + ".criterionId");
    if (!criterionId) {
      return null;
    }
    name = get(recommendation, "templateData.assessment.sections." + key + ".name");
    selectedOption = get(recommendation, "templateData.assessment.criteria." + criterionId + ".selectedOption");
    options = get(recommendation, "templateData.assessment.criteria." + criterionId + ".options");
    additionalOptions = get(recommendation, "templateData.assessment.criteria." + criterionId + ".additionalOptions", []);
    value = options.concat(additionalOptions).find(function(option) {
      return option.value === selectedOption;
    });
    researchEvidences = exportAssessmentTextSections ? renderEditorValue(get(recommendation, "templateData.assessment.researchEvidences." + key + ".content"), attachments) : void 0;
    additionalConsiderations = exportAssessmentTextSections ? renderEditorValue(get(recommendation, "templateData.assessment.additionalConsiderations." + key + ".content"), attachments) : void 0;
    if ((value == null) || value === '') {
      return null;
    }
    return [
      key, {
        name: name,
        text: value.text,
        researchEvidences: researchEvidences,
        additionalConsiderations: additionalConsiderations
      }
    ];
  }).compact().object().value();
  if (!sections) {
    return void 0;
  }
  return {
    sections: sections,
    sectionsOrder: sectionsOrder
  };
};

exportProgress = function(recommendation) {
  var progress;
  if (!recommendation) {
    return void 0;
  }
  progress = _.chain(['progress', 'plus', 'progressPlus']).map(function(field) {
    var value;
    value = getRecommendationMetadata(recommendation, field, void 0);
    if (!value) {
      return void 0;
    }
    return [field, value];
  }).compact().object().value();
  if (_.isEmpty(progress)) {
    return void 0;
  }
  return progress;
};

exportQuestionAndRecommendation = function(question, recommendations, questionStatuses, projectId, exportPlrs, exportAssessmentTextSections) {
  var attachments, certaintyOfEvidence, coexistingConditions, coi, comparison, conclusions, emlLink, evidenceTableLink, gradeCertaintyOfEvidenceLabel, headerDataPromise, individualRecommendationLink, isDiagnostic, isGps, isofData, loveLink, perspective, plainLanguageSummary, plr, presentationStatus, printoutPromise, projectName, questionModel, questionStatus, recommendation, recommendationDirection, recommendationId, recommendationStatus, recommendationStrength, recommendationText, relatedRecommendations, symptoms, _ref1, _ref2;
  if (exportPlrs == null) {
    exportPlrs = false;
  }
  if (exportAssessmentTextSections == null) {
    exportAssessmentTextSections = false;
  }
  recommendationStatus = get(questionStatuses, "" + question._id + ".recommendationStatus.status");
  if (recommendationStatus !== 'done') {
    return W.resolve();
  }
  projectName = mediator.projects.get(projectId).get('name');
  questionModel = new Question(question);
  isDiagnostic = question['type'] === 'diagnostic';
  isGps = question['type'] === 'good-practice-statement';
  recommendationId = _.first(question['recommendationIds']);
  recommendation = get(recommendations, recommendationId);
  if (!recommendation) {
    return W.resolve();
  }
  recommendationText = getRecommendationText(recommendation, isGps);
  if (!recommendationText) {
    return W.resolve();
  }
  _ref1 = getRecommendationDirectionAndStrength(recommendation), recommendationDirection = _ref1[0], recommendationStrength = _ref1[1];
  conclusions = exportConclusions(recommendation, ['recommendation', 'goodPracticeStatement']);
  conclusions['sections']['justification'] = exportJustification(recommendation);
  coexistingConditions = _.chain(getRecommendationMetadata(recommendation, 'coexistingCondition', '')[0].split(';')).map(function(value) {
    return _.str.capitalize(value.trim());
  }).compact().value();
  _ref2 = getCertaintyOfEvidenceAndLabel(recommendation), certaintyOfEvidence = _ref2[0], gradeCertaintyOfEvidenceLabel = _ref2[1];
  attachments = get(recommendation, '_attachments', {});
  coi = renderEditorValue(get(recommendation, 'templateData.question.sections.coi.content'), attachments);
  if (!coi) {
    coi = void 0;
  }
  perspective = renderEditorValue(get(recommendation, 'templateData.question.sections.perspective.content'), attachments);
  if (!perspective) {
    perspective = void 0;
  }
  comparison = question.type === 'diagnostic' && !question.comparatorTestPresent ? void 0 : [
    {
      '@id': '_:int2'
    }
  ];
  evidenceTableLink = getRecommendationMetadata(recommendation, 'evidenceTableUrl')[0];
  if (_.isEmpty(evidenceTableLink)) {
    evidenceTableLink = void 0;
  }
  loveLink = getRecommendationMetadata(recommendation, 'loveUrl')[0];
  if (_.isEmpty(loveLink)) {
    loveLink = void 0;
  }
  emlLink = getRecommendationMetadata(recommendation, 'emlUrl');
  if (_.isEmpty(emlLink)) {
    emlLink = void 0;
  }
  individualRecommendationLink = getRecommendationMetadata(recommendation, 'individualRecommendation')[0];
  if (_.isEmpty(individualRecommendationLink)) {
    individualRecommendationLink = void 0;
  }
  questionStatus = get(questionStatuses, "" + question._id + ".evidenceTableStatus.status");
  presentationStatus = get(questionStatuses, "" + question._id + ".presentationStatus.status");
  isofData = questionStatus === 'done' ? exportIsof(questionModel, projectName) : void 0;
  plainLanguageSummary = _.reject(getRecommendationMetadata(recommendation, 'plainLanguageSummary'), rejectEmptyLinks);
  relatedRecommendations = _.reject(getRecommendationMetadata(recommendation, 'relatedRecommendationLinks'), rejectEmptyLinks);
  printoutPromise = presentationStatus === 'done' ? getEtdPrintout(projectId, questionModel, recommendationId) : W.resolve(void 0);
  headerDataPromise = getRecommendationHeaderData(recommendation, question);
  symptoms = getRecommendationMetadata(recommendation, 'symptoms');
  plr = exportPlrs ? exportPlr(recommendation, isGps) : void 0;
  return W.all([printoutPromise, headerDataPromise]).then(function(_arg) {
    var etdPrintout, headerData;
    etdPrintout = _arg[0], headerData = _arg[1];
    return {
      '@id': question['_id'],
      '@type': 'WHORecommendation',
      'intervention': exportInterventions(question),
      'interventionDescription': "" + question['intervention'] + ", " + question['comparison'],
      'population': exportPopulation(question, recommendation),
      'populationDescription': question['healthProblemOrPopulation'],
      'question': [
        {
          '@id': '_:q1',
          '@type': 'WHOQuestion',
          'intervention': [
            {
              '@id': '_:int1'
            }
          ],
          'comparison': comparison,
          'population': [
            {
              '@id': '_:pop1'
            }
          ],
          'gradeCertaintyOfEvidence': certaintyOfEvidence,
          'gradeCertaintyOfEvidenceLabel': gradeCertaintyOfEvidenceLabel,
          'perspective': perspective
        }
      ],
      'recommendation': {
        'coi': coi,
        'headerData': headerData,
        'direction': recommendationDirection,
        'strength': recommendationStrength,
        'assessmentSummary': exportAssessmentSummary(recommendation, exportAssessmentTextSections),
        'conclusions': conclusions,
        'value': recommendationText
      },
      'adolopment': getRecommendationMetadata(recommendation, 'adolopment')[0],
      'recommendationIntent': _.union(['all'], getRecommendationMetadata(recommendation, 'recommendationIntent')),
      'pccModule': _.union(['all'], getRecommendationMetadata(recommendation, 'canPCCModule')),
      'recommendationIntentWHO': _.union(['all'], getRecommendationMetadata(recommendation, 'recommendationIntentWHO')),
      'intendedPopulation': getRecommendationMetadata(recommendation, 'intendedPopulation'),
      'symptoms': _.first(symptoms) === 'not_applicable' ? void 0 : symptoms,
      'interventionTypes': getRecommendationMetadata(recommendation, 'interventionTypes'),
      'hospitalization': getRecommendationMetadata(recommendation, 'hospitalization'),
      'vaccination': getRecommendationMetadata(recommendation, 'vaccination'),
      'coexistingCondition': coexistingConditions,
      'progress': exportProgress(recommendation),
      'adapted': getRecommendationMetadata(recommendation, 'adapted', false)[0],
      'informal': getRecommendationMetadata(recommendation, 'informal', false)[0],
      'research': getRecommendationMetadata(recommendation, 'research', false)[0],
      'reportedAsGPS': getRecommendationMetadata(recommendation, 'reportedAsGPS', false)[0],
      'transformed': getRecommendationMetadata(recommendation, 'transformed', false)[0],
      'sofSupplemented': getRecommendationMetadata(recommendation, 'sofSupplemented', false)[0],
      'etdModified': getRecommendationMetadata(recommendation, 'etdModified', false)[0],
      'gradingEvidenceMethod': getRecommendationMetadata(recommendation, 'gradingEvidenceMethod')[0],
      'gps': isGps,
      'diagnostic': isDiagnostic,
      'isofData': isofData,
      'evidenceTableLink': evidenceTableLink,
      'etdPrintout': etdPrintout,
      'loveLink': loveLink,
      'emlLink': emlLink,
      'individualRecommendationLink': individualRecommendationLink,
      'expertComment': renderEditorValueFromRecommendationMetadata(recommendation, 'expertComment'),
      'authors': renderEditorValueFromRecommendationMetadata(recommendation, 'authors'),
      'publicationDate': getRecommendationMetadataOrUndefined(recommendation, 'publicationDate'),
      'plainLanguageSummaryDescription': renderEditorValueFromRecommendationMetadata(recommendation, 'plainLanguageSummaryDescription'),
      'plainLanguageSummary': plainLanguageSummary,
      'relatedRecommendations': relatedRecommendations,
      'keywords': getRecommendationMetadata(recommendation, 'keywords'),
      'plr': plr
    };
  });
};

module.exports = exportQuestionAndRecommendation;
